import * as types from './types';
import { loading } from 'State/actions';

export const getChecksSummaryReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CHECKS_SUMMARY_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/ChecksSummary',
        data
      );
      dispatch({
        type: types.CHECKS_SUMMARY_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.CHECKS_SUMMARY_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.CHECKS_SUMMARY_REPORT_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.CHECKS_SUMMARY_REPORT_GET_REPORT,
    payload: null,
  };
};



// WEBPACK FOOTER //
// ./src/pages/checkssummaryreport/state/checkssummaryreport/actions.js